import app from './containers/App/stores/AppStore';
import user from './containers/App/stores/UserStore';

import inventory from './containers/Search/stores/InventoryStore';
import listings from './containers/Overview/stores/ListingsStore';
import mls from './containers/Overview/stores/MlsStore';
import sale from './containers/Sale/stores/SaleStore';
import saleWizard from './containers/SaleWizard/stores/SaleWizardStore';

const stores = {
  app,
  user,

  inventory,
  listings,
  mls,
  sale,
  saleWizard,
};

export default stores;



// WEBPACK FOOTER //
// ./src/app/stores.js